import { render } from "./ScreenDragDropCircles.vue?vue&type=template&id=1ec6a156&scoped=true&ts=true"
import script from "./ScreenDragDropCircles.vue?vue&type=script&lang=ts"
export * from "./ScreenDragDropCircles.vue?vue&type=script&lang=ts"

import "./ScreenDragDropCircles.vue?vue&type=style&index=0&id=1ec6a156&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec6a156"]])

export default __exports__